import { CohortEnumSchema } from '@eigtech/auth0-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { documentsServiceCorn } from '../base/index.js';
export const DocumentCornSchema = documentsServiceCorn('document');
export const DocumentMetadataSchema = z
    .object({
    dateTaken: z.string().datetime().optional(),
    name: z.string().optional(),
    mimeType: z.string().optional(),
    createdByCohort: CohortEnumSchema.optional(),
    label: z.string().optional(),
})
    .and(z.record(z.string(), z.any()));
export const DocumentSourceSchema = z.enum([
    'Verisk',
    'CSR',
    'TPLAP',
    'Estimator',
    'Meetings',
    'Technician',
    'Symbility',
    'Documator',
    'Invoicing',
    'Inspections',
]);
export const DocumentSource = DocumentSourceSchema.enum;
export const PublicationTargetsSchema = z.enum([
    'XactAnalysis',
    'documents',
    'Xactimate',
    'Symbility',
    'meetings',
]);
export const PublicationTargets = PublicationTargetsSchema.enum;
export const DocumentPublicationAttributesSchema = z.object({
    entityId: CornSchema,
    additionalCohorts: CohortEnumSchema.array(),
});
export const DocumentSchemaV1 = z.object({
    id: z.string(),
    claimNumber: z.string(),
    filename: z.string(),
    notes: z.string(),
    description: z.string().optional(),
    type: z.string().optional(),
    userCohorts: CohortEnumSchema.array(),
    parentFilename: z.string().optional(),
    source: DocumentSourceSchema,
    metaData: DocumentMetadataSchema.optional(),
    createdDate: z.string().optional(),
    createdBy: z.string().optional(),
    modifiedBy: z.string().optional(),
    modifiedDate: z.string().optional(),
});
export const DocumentSchemaV2 = DocumentSchemaV1.merge(z.object({
    entityId: CornSchema,
    createdByUserId: z.string().optional(),
    externalSystemId: z.string().optional(),
    title: z.string().optional(),
})).omit({
    claimNumber: true,
});
export const DocumentDataSourceSchema = z.enum(['Verisk', 'Symbility']);
export const DocumentDataSource = DocumentDataSourceSchema.enum;
export const DocumentTypeSchema = z.enum(['Photo Report', 'Draft Document']);
export const DocumentTypeEnum = DocumentTypeSchema.enum;
export const DocumentRecordSchemaV1 = DocumentSchemaV1.merge(z.object({
    PK: z.string(),
    SK: z.string(),
}));
export const DocumentRecordSchemaV2 = DocumentSchemaV2.merge(z.object({
    PK: z.string(),
    SK: z.string(),
    userCohorts: z.set(CohortEnumSchema),
}));
export const DocumentPublicationRecordSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    target: PublicationTargetsSchema,
    publicationAttributes: DocumentPublicationAttributesSchema.or(z.record(z.string(), z.unknown()).optional()),
    publishedAt: z.string(),
});
